export enum EnterpriseSize {
  MICRO = 'MICRO',

  SMALL = 'SMALL',

  MEDIUM = 'MEDIUM',

  LARGE = 'LARGE',
}
